module.exports = __webpack_public_path__ + "static/SNGLiveBlackPurple-576a3f338c09bdca4c6a6ec3c4563b33.png";